import { render, staticRenderFns } from "./mypage-navigation.vue?vue&type=template&id=51b912ff&scoped=true&"
import script from "./mypage-navigation.vue?vue&type=script&lang=js&"
export * from "./mypage-navigation.vue?vue&type=script&lang=js&"
import style0 from "./mypage-navigation.vue?vue&type=style&index=0&id=51b912ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b912ff",
  null
  
)

export default component.exports